import { Pie, PieChart, Cell, ResponsiveContainer } from 'recharts'

export type PieDatum = { name: string; value: number; color: string }

const RADIAN = Math.PI / 180

export default function PieChartWithLabel({
    data,
    height = 200,
    isAnimationActive = true,
}: {
    data: PieDatum[]
    height?: number
    isAnimationActive?: boolean
}) {
    const renderCustomizedLabel = (props: any) => {
        const { cx, cy, midAngle, innerRadius, outerRadius, payload } = props
        if (cx == null || cy == null || innerRadius == null || outerRadius == null) return null
        const nInnerRadius = Number(innerRadius)
        const nOuterRadius = Number(outerRadius)
        const radius = nInnerRadius + (nOuterRadius - nInnerRadius) * 0.4
        const ncx = Number(cx)
        const x = ncx + radius * Math.cos(-(midAngle ?? 0) * RADIAN)
        const ncy = Number(cy)
        const y = ncy + radius * Math.sin(-(midAngle ?? 0) * RADIAN)

        const datum = payload && (payload.payload ?? payload)
        const labelText = (datum && datum.name) || ''

        return (
            <text
                x={x}
                y={y}
                fontSize={14}
                fill="white"
                textAnchor={x > ncx ? 'start' : 'end'}
                dominantBaseline="central"
            >
                {labelText}
            </text>
        )
    }

    return (
        <ResponsiveContainer width={height} height={height}>
            <PieChart>
                <Pie
                    data={data}
                    labelLine={false}
                    stroke={'none'}
                    label={renderCustomizedLabel}
                    fill="#8884d8"
                    dataKey="value"
                    isAnimationActive={isAnimationActive}
                >
                    {data.map((d, i) => (
                        <Cell key={`cell-${i}`} fill={d.color} />
                    ))}
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    )
}
